import { jsx as _jsx } from "react/jsx-runtime";
import { useStatementsQuery } from 'syf-api';
import FilterDateDropdown from './dropdown';
import { useActivityContext } from '../../../context/activity-store';
import filterStatements from '../../../helpers/filter-statements';
import { StyledFilterDate } from './subcomponents';
var FilterDate = function (_a) {
    var selectedDate = _a.selectedDate, setSelectedDate = _a.setSelectedDate, excludeAllOption = _a.excludeAllOption;
    var _b = useActivityContext(), accountId = _b.accountId, config = _b.config, activeFilter = _b.activeFilter, setActiveFilter = _b.setActiveFilter;
    var statementQueryArgs = {
        config: config,
        keyProps: {
            accountId: accountId,
            accountIdType: 'guid'
        },
        queryOptions: {
            enabled: Boolean(accountId)
        }
    };
    var _c = useStatementsQuery(statementQueryArgs), statements = _c.data, isFetching = _c.isFetching;
    var statementsData = filterStatements(statements === null || statements === void 0 ? void 0 : statements.statements);
    return (_jsx(StyledFilterDate, { direction: "column", children: _jsx(FilterDateDropdown, { excludeAllOption: excludeAllOption, isDisabled: isFetching, handleChange: setSelectedDate || setActiveFilter, selectedDate: selectedDate || activeFilter, statements: statementsData }) }));
};
export default FilterDate;
//# sourceMappingURL=index.js.map